import { useApiClient } from '@/composables/useApiClient'
import type { BotOption } from './interfaces'

export const useBotService = () => {
  const apiClient = useApiClient(true)

  const getBotOptions = async (): Promise<BotOption[]> => {
    try {
      const response = await apiClient.get<BotOption[]>('/bots/options')
      return response
    } catch (error) {
      throw error
    }
  }

  return {
    getBotOptions,
  }
}
